module.exports = __webpack_public_path__ + "static/media/novedades.7d1335cd.svg";